import React, { useContext, useState } from 'react';
import { AppContext } from '@/contexts/AppContext';

const faqData = [
  {
    id: 1,
    question: "Vocês atendem emergências?",
    answer: "Não, nossa clínica não atende emergências. Trabalhamos apenas com consultas agendadas para oferecer o melhor atendimento possível."
  },
  {
    id: 2,
    question: "Qual a idade mínima para vacinar meu gatinho?",
    answer: "A primeira vacinação pode ser feita a partir de 6-8 semanas de idade. Agende uma consulta para avaliarmos o protocolo ideal para seu felino."
  },
  {
    id: 3,
    question: "Vocês fazem entrega dos produtos?",
    answer: "Sim! Entre em contato via WhatsApp para verificar a disponibilidade de entrega na sua região e os valores."
  },
  {
    id: 4,
    question: "Como agendar uma consulta?",
    answer: "Você pode agendar pelo WhatsApp ou telefone. Trabalhamos com horários marcados para garantir um atendimento tranquilo para seu gato."
  },
  {
    id: 5,
    question: "Vocês atendem outros animais além de gatos?",
    answer: "Não, somos especializados exclusivamente em felinos. Isso nos permite oferecer um cuidado mais especializado e um ambiente adequado para gatos."
  }
];

const FaqPage = () => {
  const [openFaqId, setOpenFaqId] = useState<number | null>(null);
  const context = useContext(AppContext);

  if (!context) {
    throw new Error('FaqPage must be used within an AppProvider');
  }

  const { openWhatsApp } = context;

  return (
    <section className="faq">
      <div className="container">
        <h2>❓ Perguntas Frequentes</h2>
        <p className="section-subtitle">Tire suas dúvidas sobre nossos serviços e cuidados felinos</p>
        
        <div className="faq-list">
          {faqData.map(faq => (
            <div key={faq.id} className="faq-item">
              <button 
                className={`faq-question ${openFaqId === faq.id ? 'active' : ''}`}
                onClick={() => setOpenFaqId(openFaqId === faq.id ? null : faq.id)}
              >
                <span>{faq.question}</span>
                <span className="faq-icon">{openFaqId === faq.id ? '−' : '+'}</span>
              </button>
              {openFaqId === faq.id && (
                <div className="faq-answer">
                  <p>{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
        
        <div className="faq-cta">
          <p>Não encontrou a resposta que procurava?</p>
          <button 
            className="whatsapp-button"
            onClick={() => {
              openWhatsApp('Olá! Tenho uma dúvida que não encontrei no FAQ do site.');
            }}
          >
            📱 Fale conosco
          </button>
        </div>
      </div>
    </section>
  );
};

export default FaqPage;